/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/


export enum PartNumberChangesStatusEnum {
    PENDING = 'PENDING',
    ANALYSIS = 'ANALYSIS',
    EE_ANALYSIS = 'EE_ANALYSIS',
    SOLVED = 'SOLVED',
    REJECTED = 'REJECTED',
    CANCELLED = 'CANCELLED',
}
